import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetSubscriptionsFrequencyParams } from '../types/actionParams';

export class SetSubscriptionsFrequencyRequest extends Request<ISetSubscriptionsFrequencyParams, IEmptyResult> {
    constructor(params: ISetSubscriptionsFrequencyParams) {
        super('setSubscriptionsSchedule', params);
    }
}
